<template>
  <div v-if="project" class="">
    <div class="layout__content__header layout__content__header--white">
      <AppBack :route="'/simcards/' + customerId + '/' + projectId" :text="'zpet'" />
      <h1 class="text-center mb-2 mb-md-3">
        {{ $t("SIMS_TITLE_NEW_REQUEST") }}
      </h1>
    </div>

    <div class="layout__content__header layout__content__header--white pt-0 pb-0">
      <RadioHelp
        :article-link="'/simcards/newrequest'"
        :show="showHelp"
        @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
        @update-show-radio-help="showRadioHelp($event)"
      />
    </div>
    <div v-if="radioSlides.length" class="detail-page__tabs__header d-flex">
      <div class="d-flex align-items-end detail-page__tabs__wrapper mt-5">
        <RadioOpenClose :radio-slides="radioSlides" :show="showHelp" @update-show-radio-help="showRadioHelp($event)" />
      </div>
    </div>

    <div v-if="project.projectId" class="layout__content__content">
      <div class="import-form text-left">
        <div>
          <div class="import-form__wrapper justify-content-center mt-3 mx-auto">
            <div v-if="isError" class="text-danger">
              <span v-if="isCountError">
                {{ $t("ERROR_INCORRECT_SIM_COUNT") }}
              </span>
              <span v-else>
                {{ $t("VyplnteVsechnaPovinnaPole") }}
              </span>
            </div>
          </div>
          <div class="import-form__wrapper justify-content-center mt-3 mx-auto">
            <div class="font-weight-light text-left mb-1">
              {{ $t("SIMS_LABEL_SIM_COUNT") }}
            </div>
            <div :class="{ 'has-error': isError && isCountError }" class="custom-control__custom-input w-100">
              <input
                v-model="newRequest.simCount"
                autofocus
                class="w-100"
                max="1000000"
                min="0"
                placeholder=""
                type="number"
              />
            </div>
          </div>

          <div class="import-form__wrapper justify-content-center mt-3 mx-auto">
            <div class="font-weight-light text-left mb-1">
              {{ $t("SIMS_LABEL_USE_PLACE") }}
            </div>
            <div class="custom-control__select w-100">
              <div
                :class="{
                  opened: simUsagePlaceOpened,
                  'has-error': isError && !newRequest.simUsagePlace
                }"
                class="custom-control__select__selected"
                @click="
                  () => {
                    simUnitsOpened = false
                    simDataConnectionTypeOpened = false
                    simDataAmountOpened = false
                    smsCountOpened = false
                    smsAutoRenewCountOpened = false
                    simUsagePlaceOpened = simUsagePlaceOpened ? false : true
                  }
                "
              >
                {{ newRequest.simUsagePlace ? newRequest.simUsagePlace : $t("SIMS_OPTION_CHOOSE") }}
              </div>
              <div :class="{ opened: simUsagePlaceOpened }" class="custom-control__select__options">
                <div v-for="n in 20" :key="n">
                  <div
                    v-if="$t('SIMS_OPTION_USAGEPLACE_' + n) != 'SIMS_OPTION_USAGEPLACE_' + n"
                    class="custom-control__select__option d-flex align-items-center"
                    @click="
                      () => {
                        newRequest.simUsagePlace = $t('SIMS_OPTION_USAGEPLACE_' + n)
                        simUsagePlaceOpened = false
                      }
                    "
                  >
                    <span class="font-weight-light">{{ $t("SIMS_OPTION_USAGEPLACE_" + n) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="import-form__wrapper justify-content-center mt-3 mx-auto">
            <div class="font-weight-light text-left mb-1">
              {{ $t("SIMS_LABEL_CONNECTION_TYPE") }}
            </div>
            <div class="custom-control__select w-100">
              <div
                :class="{
                  opened: simDataConnectionTypeOpened,
                  'has-error': isError && !newRequest.connectionType
                }"
                class="custom-control__select__selected"
                @click="
                  () => {
                    simUnitsOpened = false
                    simUsagePlaceOpened = false
                    simDataAmountOpened = false
                    smsCountOpened = false
                    smsAutoRenewCountOpened = false
                    simDataConnectionTypeOpened = simDataConnectionTypeOpened ? false : true
                  }
                "
              >
                {{ newRequest.connectionType ? newRequest.connectionType : $t("SIMS_OPTION_CHOOSE") }}
              </div>

              <div :class="{ opened: simDataConnectionTypeOpened }" class="custom-control__select__options">
                <div v-for="n in 20" :key="n">
                  <div
                    v-if="$t('SIMS_OPTION_CONNTYPE_' + n) != 'SIMS_OPTION_CONNTYPE_' + n"
                    class="custom-control__select__option d-flex align-items-center"
                    @click="
                      () => {
                        newRequest.connectionType = $t('SIMS_OPTION_CONNTYPE_' + n)
                        simDataConnectionTypeOpened = false
                      }
                    "
                  >
                    <span class="font-weight-light">{{ $t("SIMS_OPTION_CONNTYPE_" + n) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="import-form__wrapper justify-content-center mt-3 mx-auto">
            <div class="font-weight-light text-left mb-1">
              {{ $t("SIMS_LABEL_UNITS") }}
            </div>
            <div class="custom-control__select w-100">
              <div
                :class="{
                  opened: simUnitsOpened,
                  'has-error': isError && !newRequest.simUnits
                }"
                class="custom-control__select__selected"
                @click="
                  () => {
                    simUsagePlaceOpened = false
                    simDataConnectionTypeOpened = false
                    simDataAmountOpened = false
                    smsCountOpened = false
                    smsAutoRenewCountOpened = false
                    simUnitsOpened = simUnitsOpened ? false : true
                  }
                "
              >
                {{ newRequest.simUnits ? newRequest.simUnits : $t("SIMS_OPTION_CHOOSE") }}
              </div>
              <div :class="{ opened: simUnitsOpened }" class="custom-control__select__options">
                <div v-for="n in 20" :key="n">
                  <div
                    v-if="$t('SIMS_OPTION_UNITS_' + n) != 'SIMS_OPTION_UNITS_' + n"
                    class="custom-control__select__option d-flex align-items-center"
                    @click="
                      () => {
                        newRequest.simUnits = $t('SIMS_OPTION_UNITS_' + n)
                        simUnitsOpened = false
                      }
                    "
                  >
                    <span class="font-weight-light">{{ $t("SIMS_OPTION_UNITS_" + n) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="import-form__wrapper justify-content-center mt-3 mx-auto">
            <div class="font-weight-light text-left mb-1">
              {{ $t("SIMS_LABEL_DATA_AMOUNT") }}
            </div>
            <div class="custom-control__select w-100">
              <div
                :class="{
                  opened: simDataAmountOpened,
                  'has-error': isError && !newRequest.dataAmount
                }"
                class="custom-control__select__selected"
                @click="
                  () => {
                    simUnitsOpened = false
                    simUsagePlaceOpened = false
                    simDataConnectionTypeOpened = false
                    smsCountOpened = false
                    smsAutoRenewCountOpened = false
                    simDataAmountOpened = simDataAmountOpened ? false : true
                  }
                "
              >
                {{ newRequest.dataAmount ? newRequest.dataAmount : $t("SIMS_OPTION_CHOOSE") }}
              </div>
              <div :class="{ opened: simDataAmountOpened }" class="custom-control__select__options">
                <div v-for="n in 20" :key="n">
                  <div
                    v-if="$t('SIMS_OPTION_DATAAMOUNT_' + n) != 'SIMS_OPTION_DATAAMOUNT_' + n"
                    class="custom-control__select__option d-flex align-items-center"
                    @click="
                      () => {
                        newRequest.dataAmount = $t('SIMS_OPTION_DATAAMOUNT_' + n)
                        simDataAmountOpened = false
                      }
                    "
                  >
                    <span class="font-weight-light">{{ $t("SIMS_OPTION_DATAAMOUNT_" + n) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="import-form__wrapper justify-content-center mt-3 mx-auto">
            <div class="font-weight-light text-left mb-1">
              {{ $t("SIMS_LABEL_SMS_COUNT") }}
            </div>
            <div class="custom-control__select w-100">
              <div
                :class="{
                  opened: smsCountOpened,
                  'has-error': isError && !newRequest.smsCount
                }"
                class="custom-control__select__selected"
                @click="
                  () => {
                    simUnitsOpened = false
                    simUsagePlaceOpened = false
                    simDataConnectionTypeOpened = false
                    simDataAmountOpened = false
                    smsAutoRenewCountOpened = false
                    smsCountOpened = smsCountOpened ? false : true
                  }
                "
              >
                {{ newRequest.smsCount ? newRequest.smsCount : $t("SIMS_OPTION_CHOOSE") }}
              </div>
              <div :class="{ opened: smsCountOpened }" class="custom-control__select__options">
                <div v-for="n in 20" :key="n">
                  <div
                    v-if="$t('SIMS_OPTION_SMSCOUNT_' + n) != 'SIMS_OPTION_SMSCOUNT_' + n"
                    class="custom-control__select__option d-flex align-items-center"
                    @click="
                      () => {
                        newRequest.smsCount = $t('SIMS_OPTION_SMSCOUNT_' + n)
                        smsCountOpened = false
                      }
                    "
                  >
                    <span class="font-weight-light">{{ $t("SIMS_OPTION_SMSCOUNT_" + n) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="import-form__wrapper d-flex justify-content-end mt-4 mx-auto">
            <div class="btn btn-primary" @click="checkInputs()">
              {{ $t("SIMS_BTN_SEND_NEW_SIM_REQUEST") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="layout__content__content layout__content__content--white">
      <p class="text-center">
        {{ $t("neniVybranProjekt") }}
      </p>
    </div>
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
    <InfoModal :centered="true" :opened="openedInfoConfirmation" :text="infoText" @close="toggleInfo" />
  </div>
</template>

<script>
import axios from "axios"
import RadioHelp from "@/components/radio/radio-help.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import Back from "@/components/back.vue"
import ErrorModal from "@/components/confirmations/error.vue"
import InfoModal from "@/components/confirmations/info.vue"
import { useProjectStore } from "@/store/modules/project"
import { useCustomerStore } from "@/store/modules/customer"
import { useAuthStore } from "@/store/modules/auth"
import { useConfigStore } from "@/store/modules/config"

export default {
  components: {
    AppBack: Back,
    ErrorModal,
    RadioHelp,
    RadioOpenClose,
    InfoModal
  },
  setup() {
    const projectStore = useProjectStore()
    const customerStore = useCustomerStore()
    const authStore = useAuthStore()
    const configStore = useConfigStore()

    return { projectStore, authStore, customerStore, configStore }
  },
  data() {
    return {
      infoText: "SIMS_NEW_REQUEST_SENT",
      openedInfoConfirmation: false,
      radioSlides: [],
      showHelp: true,
      loading: false,
      projectId: this.$route.params.projectId,
      customerId: this.$route.params.customerId,
      newRequest: {
        simCount: 0,
        simUnits: "",
        simUsagePlace: "",
        dataAmount: "",
        smsCount: "",
        smsAutoRenew: false,
        smsAutoRenewCount: "",
        connectionType: ""
      },
      simUsagePlace: "",
      errors: {
        custDeviceName: ""
      },
      simUnitsOpened: false,
      simUsagePlaceOpened: false,
      simDataConnectionTypeOpened: false,
      simDataAmountOpened: false,
      smsCountOpened: false,
      smsAutoRenewCountOpened: false,
      isError: false,
      errorsToTranslate: [],
      openedError: false,
      isCountError: false
    }
  },
  computed: {
    services() {
      /**
       * we must use only service which is not suspended or discontinued
       */
      let storedServices = this.$store.getters["services/services"]
      let services = []
      for (let i = 0; i < storedServices.length; i++) {
        if (storedServices[i].suspended == false && storedServices[i].discontinued == false) {
          services.push(storedServices[i])
        }
      }
      return services
    },
    apiUser() {
      return this.authStore.apiUser
    },
    project() {
      return this.projectStore.selectedProject
    },
    customer() {
      return this.customerStore.selectedCustomer
    },
    user() {
      return this.authStore.user
    },
    locale() {
      return this.$i18n.locale
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    }
  },
  watch: {
    /*
    "newRequest.simUsagePlace"(newValue) {
      if (newValue == "EURO" || newValue == "GLOBAL") {
        if (this.newRequest.connectionType == "NB-IOT") {
          this.newRequest.connectionType = "LTE-3G_TELEMETERY";
        }
      }
    },
    */
    radioDisabled() {
      this.showHelp = !this.radioDisabled
    }
  },
  mounted() {
    this.showHelp = !this.radioDisabled
  },
  methods: {
    switchSmsAutoRenew() {
      this.newRequest.smsAutoRenew = !this.newRequest.smsAutoRenew
    },
    sendRequest() {
      this.$store.commit("modals/setWaitingLoader", this.$t("SIMS_SENDING_REQUEST_LOADER"))
      axios
        .post(
          process.env.VUE_APP_APICMS +
            "/forms/newsim?token=" +
            this.user.access_token +
            "&email=" +
            this.apiUser.email +
            "&jmeno=" +
            this.apiUser.firstName +
            "&prijmeni=" +
            this.apiUser.lastName +
            "&customer=" +
            this.customer.customerName +
            "&customerId=" +
            this.customerId +
            "&project=" +
            this.project.projectName +
            "&projectId=" +
            this.projectId,
          this.newRequest
        )
        .then(() => {
          this.$store.commit("modals/setWaitingLoader", "")
          this.setInfo("SIMS_NEW_REQUEST_SENT")
          this.toggleInfo()
          this.resetRequestModel()
        })
        .catch(() => {
          this.$store.commit("modals/setWaitingLoader", "")
          this.setInfo("SIMS_NEW_REQUEST_ERROR")
          this.toggleInfo()
        })
    },
    resetRequestModel() {
      this.newRequest = {
        simCount: 0,
        simUnits: "",
        simUsagePlace: "",
        dataAmount: "",
        smsCount: "",
        smsAutoRenew: false,
        smsAutoRenewCount: "",
        connectionType: ""
      }
    },
    checkInputs() {
      console.log(this.project)
      console.log(this.customer)

      this.isError = false
      this.isCountError = false
      if (this.newRequest.simCount < 1 || this.newRequest.simCount > 1000000) {
        this.isError = true
        this.isCountError = true
      }
      if (!this.newRequest.simUsagePlace) this.isError = true
      if (!this.newRequest.simUnits) this.isError = true
      if (!this.newRequest.dataAmount) this.isError = true
      if (!this.newRequest.smsCount) this.isError = true
      //if (!this.newRequest.smsAutoRenewCount) this.isError = true;
      if (!this.newRequest.connectionType) this.isError = true

      if (!this.isError) {
        this.sendRequest()
      }
    },
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    },
    setInfo(infoText) {
      this.infoText = infoText
    },
    toggleInfo() {
      this.openedInfoConfirmation = this.openedInfoConfirmation ? false : true
    }
  }
}
</script>

<style scoped></style>
